import { Navigation } from "../../interfaces/Navigation";
import { PermissionMenuName } from "../../interfaces/UserRole";

const navMasterData: Navigation = {
  title: 'Master Data',
  items: [
    {
      title: "Bentuk Kerjasama",
      route: "/bentuk-kerjasama",
      icon: "fa fa-database",
      permissionId: PermissionMenuName.masterData
    },
    {
      title: "Jenis Dokumen",
      route: "/jenis-dokumen",
      icon: "fa fa-database",
      permissionId: PermissionMenuName.masterData
    },
    {
      title: "Jenis Lembaga",
      route: "/jenis-lembaga",
      icon: "fa fa-database",
      permissionId: PermissionMenuName.masterData
    },
    {
      title: "Status Kerjasama",
      route: "/status-kerjasama",
      icon: "fa fa-database",
      permissionId: PermissionMenuName.masterData
    }
  ]
}

export default navMasterData;